import React, { createContext, useState } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState("");
  const [cambio, setCambio] = useState(true);
  const [existe, setExiste] = useState(false);

  return (
    <DataContext.Provider
      value={{ data, setData, cambio, setCambio, existe, setExiste }}
    >
      {children}
    </DataContext.Provider>
  );
};
